import {Component} from '@angular/core';
import {environment} from '../../../environments/environment';
import {AppStateService} from '../../shared/app-state.service';
import {AuthService} from '../../shared/auth.service';

@Component({
  selector: 'app-footer',
  templateUrl: './app-footer.component.html',
  styleUrls: ['./app-footer.component.scss'],
  // changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppFooterComponent {

  year = new Date().getFullYear();
  debugMenu = environment.flags.debugMenu;
  minimal$ = this.AppState.minimal$;
  brand$ = this.AppState.brand$;
  locale$ = this.AppState.locale$;
  user$ = this.Auth.user$;
  masquerading$ = this.Auth.masquerading$;

  constructor(private AppState: AppStateService,
              private Auth: AuthService) {
  }
}
